/**
 * Shared motion tokens for JS-driven (framer-motion) surfaces.
 *
 * These mirror the CSS motion in app/globals.css (the `cubic-bezier(0.16,1,0.3,1)`
 * "brand decelerate" curve used by dialogs, chat panels, and entrance classes),
 * so framer-motion animations move on the SAME curve as CSS ones and the whole
 * app feels like one product. Import these instead of hand-typing easing arrays
 * or `ease: "easeOut"` per component. See docs/design-guidelines.md §14.
 */

// cubic-bezier control points — framer-motion accepts this array form.
export const EASE_PREMIUM = [0.16, 1, 0.3, 1];

// Standard durations (seconds). Keep motion in the 150–340ms band.
export const DURATION = {
  fast: 0.16,
  base: 0.26,
  slow: 0.34,
};
